"use client";
import React from "react";
import Image from "next/image";

import { CustomInput } from "@/components/CustomInput";
import { CustomTextarea } from "@/components/CustomInput";
import { message } from "antd";

import img from "@/assets/contactBanner.png";

import { yupResolver } from "@hookform/resolvers/yup";
import { useMutation } from "@tanstack/react-query";
import { Controller, useForm } from "react-hook-form";
import InputError from "@/components/InputError";
import schema from "./schema";
import { sendMail } from "@/api/send-mail.service";

const Contact = () => {
  const {
    getValues,
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
  });

  const { mutate: sendMailMutation, isLoading } = useMutation((data: any) => sendMail(data), {
    onSuccess(response: any) {
      message.success("Success!");
    },
    onError(err: any) {
      message.error(err.response?.data?.message);
    },
  });

  const onSubmit = () => {
    const data = getValues();
    sendMailMutation(data);
  };

  return (
    <>
      <div className="grid grid-cols-1 lg:grid-cols-2 pb-6">
        <div className="hidden lg:block">
          <Image src={img} alt="" className="object-cover object-center h-full w-full" />
        </div>
        <div className="flex justify-center px-4 md:px-0 py-12 md:py-[56px] lg:py-[64px]">
          <div className="w-full md:w-[512px]">
            <div className="mb-9 md:mb-12">
              <h1 className="font-semibold text-third text-[24px] md:text-[32px] lg:text-[48px] mb-4 md:mb-6">
                Liên hệ
              </h1>
              <h2 className="text-secondary text-[16px] md:text-[20px]">Gửi câu hỏi cho chúng tôi</h2>
            </div>

            <div className="flex flex-col gap-4 mb-6">
              <Controller
                name="fullname"
                control={control}
                render={({ field: { onChange, value } }) => (
                  <div>
                    <CustomInput className="!h-12" placeholder="Họ và tên" onChange={onChange} value={value} />
                    <InputError error={errors.fullname?.message} />
                  </div>
                )}
              />

              <Controller
                name="email"
                control={control}
                render={({ field: { onChange, value } }) => (
                  <div>
                    <CustomInput className="!h-12 " placeholder="Email" onChange={onChange} value={value} />
                    <InputError error={errors.email?.message} />
                  </div>
                )}
              />

              <Controller
                name="phoneNumber"
                control={control}
                render={({ field: { onChange, value } }) => (
                  <div>
                    <CustomInput className="!h-12 " placeholder="Số điện thoại" onChange={onChange} value={value} />
                    <InputError error={errors.phoneNumber?.message} />
                  </div>
                )}
              />

              <Controller
                name="message"
                control={control}
                render={({ field: { onChange, value } }) => (
                  <div>
                    <CustomTextarea placeholder="Nội dung" onChange={onChange} value={value} rows={4} />
                    <InputError error={errors.message?.message} />
                  </div>
                )}
              />
            </div>

            <div onClick={() => {}} className="btn-primary h-[56px] w-[121px]">
              Liên hệ
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;
